
export const root = {
    background: '{overlay.modal.background}',
    borderColor: '{overlay.modal.border.color}',
    color: '{overlay.modal.color}',
    shadow: '{overlay.modal.shadow}'
};

export const header = {
    padding: '{overlay.modal.padding}'
};

export const title = {
    fontSize: '1.5rem',
    fontWeight: '400'
};

export const content = {
    padding: '0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}'
};

export const footer = {
    padding: '{overlay.modal.padding}'
};

export default {
    root,
    header,
    title,
    content,
    footer
};
